import { Component, OnDestroy, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import { DownloadElement, DownloadService } from '../shared/services/download.service';
import { Subject, takeUntil } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { OktaService } from '../shared/services/okta.service';
import { HcToastOptions, HcToasterService } from '@healthcatalyst/cashmere';
import { environment } from '../../environments/environment';

// Pointer to Google Analytics gTag function defined in index.html
declare let gtag: Function;

/** Public facing landing page of available downloads  */
@Component({
    selector: 'pd-downloads',
    templateUrl: './downloads.component.html',
    styleUrls: ['./downloads.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class DownloadsComponent implements OnInit, OnDestroy {
    private unsubscribe = new Subject<void>();
    loading = true;
    loadError = false;
    techLibrary: DownloadElement;
    metadata: DownloadElement;

    get techLibraryName(): string {
        return this.techLibrary ? this.techLibrary.name : 'No version available';
    }

    get metadataName(): string {
        return this.metadata ? this.metadata.name : 'No version available';
    }

    constructor( 
        private downloadService: DownloadService,
        private http: HttpClient,
        private oktaService: OktaService,
        private toasterService: HcToasterService
    ) {}

    ngOnInit(): void {
        this.downloadService.downloadsUpdated.pipe(takeUntil(this.unsubscribe)).subscribe(list => {
            if (list) {
                list.forEach(element => {
                    if ( element.type === 'techlibrary' ) {
                        if ( !this.techLibrary || (this.techLibrary && element.version > this.techLibrary.version) ) {
                            this.techLibrary = element;
                        }
                    } else if ( element.type === 'metadata' ) {
                        if ( !this.metadata || (this.metadata && element.version > this.metadata.version) ) {
                            this.metadata = element;
                        }
                    }
                });

                this.loading = false;
                this.loadError = false;
            } else {
                this.loadError = this.downloadService.loadFailed;
                if ( !this.loadError ) {
                    this.downloadService.refresh();
                } else {
                    this.loading = false;
                }
            }
        });
    }

    reloadDownloads(): void {
        this.downloadService.refresh();
    }

    downloadFile( type: string ): void {
        let element: DownloadElement = this.techLibrary;

        if ( type === 'metadata' ) {
            element = this.metadata;

            gtag('event', 'file_download', {
                'event_label' : element.name,
                'file_type': 'Catalog Spreadsheet'
            });
        }

        let headers = new HttpHeaders();
        headers = headers.append('Authorization', `Bearer ${this.oktaService.accessToken}`);

        this.http.get(environment.azure.url + '/document?file=' + element.azureID, { responseType: 'blob', headers: headers }).subscribe({
            next: (data) => {
                const blob = new Blob([data], { type: element.fileType });
                const url= window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.setAttribute('type', 'hidden');  
                a.href = url;  
                a.download = element.type === 'techlibrary' ? element.name + '.pdf' : element.name + '.xlsx';  
                a.click(); 
                a.remove();
            },
            error: (msg) => {
                const options: HcToastOptions = {
                    header: 'Download Failed',
                    body: 'Unable to download file. Try again later.',
                    type: 'alert',
                    position: 'bottom-right'
                };
                this.toasterService.addToast(options);
                console.log(msg);
            }
        });
    }

    ngOnDestroy() {
        this.unsubscribe.next();
        this.unsubscribe.complete();
    }
}
